/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Dialogs_Delete_TitleInputs */

const es_admin_users_dialogs_delete_title = /** @type {(inputs: Admin_Users_Dialogs_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar usuario`)
};

const en_admin_users_dialogs_delete_title = /** @type {(inputs: Admin_Users_Dialogs_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete user`)
};

/**
* | output |
* | --- |
* | "Delete user" |
*
* @param {Admin_Users_Dialogs_Delete_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_dialogs_delete_title = /** @type {((inputs?: Admin_Users_Dialogs_Delete_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Dialogs_Delete_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_dialogs_delete_title(inputs)
	return en_admin_users_dialogs_delete_title(inputs)
});
export { admin_users_dialogs_delete_title as "admin.users.dialogs.delete.title" }